import { FC } from "react";
import { Button, Stack } from "@mui/material";
import FeaturedPlayListOutlinedIcon from "@mui/icons-material/FeaturedPlayListOutlined";
import { FilterItemNodeWithId } from "@/components/pages/common/filters-tree/utils/types/common";
import { FilterValue } from "@/components/pages/common/filters-tree/filters-selection/components/provider-dynamic-filters/filter-item/components/filter-value/FilterValue";
import { useMenuHook } from "@/utils/hooks/useMenu.hook";
import { FilterValueWithBatchInputPopover } from "@/components/pages/common/filters-tree/filters-selection/components/provider-dynamic-filters/filter-item/components/filter-value/components/filter-value-with-batch-input/components/FilterValueWithBatchInputPopover";

interface FilterValueWithBatchInputProps {
  valueHasKey: boolean;
  filter: FilterItemNodeWithId;
  onChange(value: FilterItemNodeWithId["value"]): void;
}

export const FilterValueWithBatchInput: FC<FilterValueWithBatchInputProps> = ({
  filter,
  onChange,
  valueHasKey,
}) => {
  const { anchor, open, openMenu, closeMenu } = useMenuHook();

  return (
    <Stack>
      <FilterValue inBatchInput filter={filter} onChange={onChange} />

      <Button
        variant="text"
        size="small"
        onClick={openMenu}
        startIcon={<FeaturedPlayListOutlinedIcon fontSize="small" />}
        sx={{ alignSelf: "start", textDecoration: "underline" }}
      >
        Input batch values
      </Button>

      <FilterValueWithBatchInputPopover
        open={open}
        filter={filter}
        anchor={anchor}
        onChange={onChange}
        onClose={closeMenu}
        valueHasKey={valueHasKey}
      />
    </Stack>
  );
};
